var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],staticClass:"fa fa-users",style:({opacity: _vm.ad.third_party_costs ? 1 : 0.2})})
}
var staticRenderFns = []

export { render, staticRenderFns }